// SystemPulse — the top-of-dashboard vital-signs strip.
// One glance answers: what needs me, what's on my desk, how heavy is
// today, and has ARIA connected anything across sources.
// Each item: { label, value, sub, status, onClick, title }
// status: 'needs-action' | 'important' | 'busy' | 'moderate' | 'aria' | 'clear'
import React from 'react';

export default function SystemPulse({ items }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="hm-pulse" role="group" aria-label="System pulse">
      {items.map((item, i) => (
        <button
          key={i}
          type="button"
          className={`hm-pulse-tile hm-pulse-${item.status || 'moderate'}`}
          onClick={item.onClick}
          title={item.title || item.label}
        >
          <span className="hm-pulse-value">{item.value}</span>
          <span className="hm-pulse-meta">
            <span className="hm-pulse-label">{item.label}</span>
            {item.sub && <span className="hm-pulse-sub">{item.sub}</span>}
          </span>
        </button>
      ))}
    </div>
  );
}
